import {A11y, Autoplay, Navigation, Pagination, Scrollbar} from "swiper";
import {Swiper, SwiperSlide} from "swiper/react";
import Image from "../Image";
import {pathMaker} from "../../../utilities/helperFunctions";
import React, {useLayoutEffect, useRef, useState} from "react";
import useAxios from "../../../services/useAxios";
import {removeCommas} from "@persian-tools/persian-tools";
import toast from "react-hot-toast";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import useWindowSize from "../../../hooks/useWindowSize";


const BoxSlider = ({banner, width, height}) => {
    const navigate = useNavigate();

    const onClickImage = async (id, url) => {
        let formData = new FormData();
        formData.append("banner_id", "" + id);

        await axios
            .post(
                "https://sabadi.ir/api/api/click_banner",
                formData
            )
            .then(({data}) => {
                if (data.status != 1) {
                    console.log("Error-apiClickBaner: ", data);
                }
                if (url) {
                    navigate(url);
                }
            })
            .catch((err) => {
                if (url) {
                    navigate(url);
                }
                console.log(err);
            });
    }

    return (banner.type == "slider") ? (
        <div className="mr-t-12">
            <Swiper
                modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
                slidesPerView={1}
                autoplay={{delay: 6000}} // navigation
                pagination={{clickable: true}}>
                <div style={{borderRadius: "6px"}}>
                    {banner.items.map(item => (
                        <SwiperSlide>
                            <div className="d-flex justify-content-center">
                                <img
                                    onClick={() => onClickImage(item.id, item.url)}
                                    style={{
                                        width: (width) ? width : "100%",
                                        height: (height) && height,
                                        borderRadius: "6px",
                                        cursor: (item.url) && "pointer"
                                    }}
                                    src={pathMaker(item.image)}
                                    // src="https://sabadi.ir/api/uploads/menu/3.jpg"
                                ></img>
                            </div>
                        </SwiperSlide>
                    ))}
                </div>
            </Swiper>
        </div>

    ) : banner.items.map(item => (
            <div className="mr-t-12">
                <SwiperSlide>
                    <div className="d-flex justify-content-center">

                        <img
                            onClick={() => onClickImage(item.id, item.url)}
                            style={{
                                width: (width) ? width : "100%",
                                height: (height) && height,
                                borderRadius: "6px",
                                cursor: (item.url) && "pointer"
                            }}
                            src={pathMaker(item.image)}
                            // src="https://sabadi.ir/api/uploads/menu/3.jpg"
                        ></img>
                    </div>
                </SwiperSlide>
            </div>
        )
    )
}
export default BoxSlider;